import { createUseStyles } from 'react-jss';

export default createUseStyles({
  calendarHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    '& span': {
      fontWeight: '500',
      fontSize: '24px',
      textAlign: 'center',
      color: '#102131',
    },
  },
  cell: {
    fontSize: '24px',
    textAlign: 'center',
    width: '56px',
    height: '56px',
    userSelect: 'none',
  },

  thisMonth: {
    color: '#102131',
  },

  notThisMonth: {
    color: '#B2B9C0',
  },

  currentDay: {
    color: 'white',
    borderRadius: '100%',
    backgroundColor: '#102131',
  },

  hoverable: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(16,33,49, 0.08)',
      borderRadius: '100%',
    },
  },
});
